var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatisticsFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "url(#paint0_linear_6391_60483)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6391_60483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4297 13C18.3714 13 13.4429 18.0567 13.4429 24.2726C13.4429 30.4884 18.3714 35.5451 24.4297 35.5451C30.4881 35.5451 35.4166 30.4884 35.4166 24.2726C35.4166 18.0567 30.4881 13 24.4297 13ZM24.4297 33.6663C22.1408 33.6663 20.0506 32.7937 18.4437 31.3639C18.4511 31.3517 18.4611 31.3414 18.4675 31.3292C19.9801 28.729 19.0288 27.1405 18.3265 26.4247C18.1416 26.2359 17.9301 26.0639 17.7122 25.8911C17.1427 25.4374 16.7655 25.1377 16.7655 24.2726C16.7655 23.8649 16.9871 23.7052 18.0812 23.3219C18.8338 23.0579 19.6862 22.7592 20.2364 22.0293C21.5136 20.3347 20.1092 17.7213 19.8143 17.2141C19.6633 16.9538 19.4994 16.7096 19.3291 16.4757C20.7052 15.5251 22.3477 14.9577 24.113 14.8947C24.3986 15.3917 24.8701 15.8106 25.3334 16.2193C25.7289 16.5687 26.357 16.7152 26.6802 17.1286C26.8652 17.3653 26.7754 17.8218 26.7819 18.1206C26.7947 18.7133 27.1444 19.5728 28.3237 19.5728C28.3759 19.5728 28.4299 19.571 28.4857 19.5672C28.9417 19.5343 30.3645 19.1999 31.7946 18.7152C32.9153 20.2746 33.5855 22.1928 33.5855 24.2726C33.5855 29.4523 29.4782 33.6663 24.4297 33.6663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6471 21.3633C26.2041 21.3633 24.731 22.0669 23.9821 23.1133C23.4794 23.816 23.3329 24.6286 23.5691 25.4017C24.0406 26.9441 24.0864 27.8535 23.7916 28.8727C23.5298 29.7782 23.5041 31.0915 24.9993 31.7171C25.2812 31.8355 25.5907 31.8956 25.9167 31.8956C27.0282 31.8956 28.3438 31.1901 29.5277 29.9586C30.9505 28.4791 31.7873 26.6661 31.7672 25.1067C31.7397 23.0081 29.9296 21.3633 27.6471 21.3633Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6391_60483",
    x1: 7.94287,
    y1: 7,
    x2: 37.4429,
    y2: 43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B7047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B7047"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6391_60483"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.9737,
    height: 22.5451,
    fill: "white",
    transform: "translate(13.4429 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticsFood);
export default __webpack_public_path__ + "static/media/statistics-food.8401edeaeaae6b8554ac7964d77acbb4.svg";
export { ForwardRef as ReactComponent };